"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import AvatarCount from "./AvatarCount";
import "../../Home.css";
import "../../Buttons.css";
import dynamic from "next/dynamic";

// The deals popup only renders after the hero button is clicked, so its
// code (BannerDeals -> PopupCourseCards -> dayjs, discount hooks, card/
// pagination components) is split out of the initial bundle. It is warmed
// on pointer/focus intent below so the click itself still opens instantly.
const loadBannerButtonPopup = () => import("./BannerButtonPopup");
const BannerButtonPopup = dynamic(loadBannerButtonPopup, { ssr: false });

// Hero entrance animation (see .hero-content-anim/.hero-image-anim in
// Home.css) — matches the CRA app's Framer Motion hero animation (text
// slides in from the left, image from the right, fading in together)
// using plain CSS transform/opacity instead of framer-motion, so there's
// no lazy-loaded-library delay to the LCP paint and no layout pass (only
// compositor-handled properties), while still landing the same visual
// entrance. Runs once via animation-fill-mode, never replaying on
// re-render.
const Banner = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="home-banner-background container">
        <div className="home-banner">

        {/* Left side content */}
        <div className="home-content hero-content-anim">
          <h1 className="home-title">
            <span className="home-title-span">Boost Your Career</span> with
            <br />
            Industry-Recognized
            <br />
            IT Certifications
          </h1>

          <p className="home-title-text">
            Learn from flexible, affordable, and expert-designed courses trusted by
            25,000+ learners worldwide. Upgrade your skills anytime, anywhere – and
            achieve your career goals faster.
          </p>

          <div className="avatar-row">
            <AvatarCount />
            <span className="home-sub-text">Join with us</span>
          </div>

          <div className="button-row">
            <button
              className="home-start-button hero-start-button"
              onClick={() => setShowPopup(true)}
              onPointerEnter={loadBannerButtonPopup}
              onFocus={loadBannerButtonPopup}
              onTouchStart={loadBannerButtonPopup}
            >
              Start Your Certification
            </button>

            <Link href="/courses" className="home-browse-button hero-browse-button" prefetch={false}>
              Browse All Courses
            </Link>
          </div>
        </div>

        {/* Right side image */}
        <Image
          className="home-banner-img hero-image-anim"
          src="/industry-recognized-it-certifications.webp"
          alt="Home banner"
          priority
          fetchPriority="high"
          width={429}
          height={521}
          // Served straight from public/ (429px wide - the optimizer can't
          // upscale it, so every srcset width returned ~the same pixels): skips
          // the /_next/image server round trip for the LCP image and uses the
          // immutable cache header from next.config.mjs.
          unoptimized
        />

        {showPopup && <BannerButtonPopup onClose={() => setShowPopup(false)} />}
      </div>
      </div>
    </>
  );
};

export default Banner;
